<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <keep-alive>
        <route-view />
      </keep-alive>
      <div class="footer">
        <div class="copyright">
          Copyright &copy MegaTechnology
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from './RouteView'
  import { mixinDevice } from '@/utils/mixin'
  import Vue from 'vue'
  import { SCREEN_HEIGHT } from '@/store/mutation-types'

  export default {
    name: 'UserLayout',
    components: { RouteView },
    mixins: [mixinDevice],
    data() {
      return {
        screenHeight: Vue.ls.get(SCREEN_HEIGHT)
      }
    },
    mounted() {
      document.body.classList.add('userLayout')
    },
    beforeDestroy() {
      document.body.classList.remove('userLayout')
    }
  }
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background-color: #3868cf;
      background-image: url(~@/assets/login.jpg);
      background-position: center;
      background-repeat: no-repeat, no-repeat;
      background-size: cover;
      padding: 130px 0 10px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 20px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -4px;
            opacity: 0.8;
          }

          /*.title {*/
          /*font-size: 33px;*/
          /*!*color: rgba(0, 0, 0, .85);*!*/
          /*color: #1890ff;*/
          /*font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;*/
          /*font-weight: 600;*/
          /*position: relative;*/
          /*top: 0;*/
          /*}*/
        }

        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 450px;
        height: 400px;
        margin: auto;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.4);
      }

      .about {
        position: absolute;
        width: 100%;
        top: 0;
        right: 0;
        padding: 0 16px;
        margin: 24px 0 24px;
        text-align: right;

        .link-about {
          margin-bottom: 8px;
          margin-right: 10px;
          font-size: 14px;

          a {
            /*color: rgba(0, 0, 0, 0.45);*/
            transition: all 0.3s;

            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 24px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;

          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;

            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }

        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }

    .logo {
      height: 70px;
      margin: 5px 20px 20px 20px;
      border-style: none;
      text-align: left;
      position: relative;
      left: 5px;
      top: 0;
    }
  }
</style>
